import React, { useEffect, useState } from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { APP_ENGLISH_VIOLET_COLOR, APP_WHITE_COLOR } from '../assets/constants/Colors';
import { HAMBERGER_ICON, DARK_HAMBERGER_ICON, UserIcon, UserIconDark, LoginIcon, LoginIconDark } from "../assets/constants/Icons";
import { useTranslation } from 'react-i18next';
import { MAIN_HEADER_LEFT_ICON, MAIN_HEADER_RIGHT_ICON } from '../assets/constants/Constants';
import { HOME, EQUIPMENT_GRID, MENU_DRAWER, CHAT_SUPPORT} from '../assets/constants/PageList';
import { clearLocalStorageForUser, getPageNameUsingPath, getPathForNextPage } from '../lib/Utils';

import DuroltLogoIcon from "../assets/images/durolt_logo_new.svg";
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LOCKER_SLUG, LS_BANKID, LS_CUSTOMER, USER_INFO } from '../assets/constants/BrowserStorageKeys';
import { isGuestUserAuthenticated } from '../lib/AuthUtils';
const MainHeader = ({ isDrawerOpened }) => {
    const [clientLogo, setClientLogo] = useState('');
    const history = useHistory();
    const theme = useTheme();
    const { t } = useTranslation();
    const colorScheme = theme.palette.mode;

    const openMenu = () => {
        const currentPage = getPageNameUsingPath(history.location.pathname) || HOME;
        if(currentPage === 'map'){
            history.push('/custom-drawer', { isDrawerOpened: true });
            return;
        }
        const nextPath = getPathForNextPage(currentPage, MENU_DRAWER);
        history.push(nextPath || '/custom-drawer', { isDrawerOpened: true });
    };

    const openDashboard = async() => {
        // if user has login as gess user then redirect to "/" with clear the login data from local storage
        const userData = await getSecureItemFromSpecificStorage(
                LOCAL_STORAGE,
                USER_INFO
            );
        if(userData){
            history.push('/');
            return;
        }
        else{
            clearLocalStorageForUser(getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER))
            history.push('/');
        }
    };

    const getTenantLogo = async () => {
        try {
            const domain = localStorage.getItem('domain'); 
            if (domain) {
                const response = "" 
                if (response) {
                    const logo = response.data.main_logo || '';
                    setClientLogo(logo);
                }
            }
        } catch (error) {
            console.error('getTenantLogo error==', error);
        }
    };

    useEffect(() => {
        getTenantLogo();
    }, []);

    const handleNavigateToNotification = () => {
        const userInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO);
        const isUserAuthenticated = isGuestUserAuthenticated(userInfo);
        const LokcerSlug = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LOCKER_SLUG);

        if (!isUserAuthenticated && LokcerSlug) {
            history.push('/login-page');
            return;
        }
        history.push('/user-account');
    }

    const handleOpenChatSupport = () => {
        history.push(getPathForNextPage(EQUIPMENT_GRID, CHAT_SUPPORT));
    }

    const handleCloseDrawer = () => {
        const closeRedirectPath = history.location.state?.closeRedirectPath;
        if (closeRedirectPath) {
            history.push(closeRedirectPath);
            return;
        }
        window.history.back();
    };

    const userInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO);
    const isUserAuthenticated = isGuestUserAuthenticated(userInfo);
    const lockerSlug = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LOCKER_SLUG);
    const showLoginIcon = !isUserAuthenticated && lockerSlug;

    return (
        <Box className='main-header-page'>
            <Box className='main-container'>
                <Box className='main' sx={{ backgroundColor: colorScheme === 'dark' ? APP_ENGLISH_VIOLET_COLOR : APP_WHITE_COLOR }}>
                    <Box className={`header ${colorScheme == 'dark' ? 'dark-header' : null}`}>
                        {isDrawerOpened ? (
                            <IconButton onClick={handleCloseDrawer}>
                                <img className={`header-left-icon header-cancel-icon ${colorScheme === 'dark' ? 'dark' : ""}`} src={t('cancelIcon') !== 'cancelIcon' ? t('cancelIcon') : require('../assets/images/cancel.png')} alt="Icon" />
                            </IconButton> 
                        ) : (
                            t('mainHeaderLeftIcon') !== MAIN_HEADER_LEFT_ICON ? (
                                <IconButton onClick={openMenu}>
                                    <img className='header-left-icon' src={t('mainHeaderLeftIcon')} alt="Icon" />
                                </IconButton> 
                            ) : (
                                <IconButton onClick={openMenu}>
                                    {colorScheme === 'dark' ? <DARK_HAMBERGER_ICON /> : <HAMBERGER_ICON />}
                                </IconButton>
                            )
                        )}
                        <Box className="header-contain">
                            <Box className="header-content">
                                <IconButton onClick={openDashboard}>
                                    {t("appHeaderLogo") !== "appHeaderLogo" ? (
                                        <img className="app-header-logo" src={t('appHeaderLogo')} alt="App Logo" />
                                    ) : (
                                        <img src={DuroltLogoIcon} width={120}  alt="Durolt Logo" />
                                    )}
                                </IconButton>
                            </Box>
                        </Box>
                        {t('mainHeaderRightIcon') !== MAIN_HEADER_RIGHT_ICON ? (
                            <IconButton onClick={handleOpenChatSupport}>
                                <img className='header-right-icon' src={t('mainHeaderRightIcon')} alt="Icon" />
                            </IconButton>
                        ) : (
                            <IconButton onClick={handleNavigateToNotification}>
                                {showLoginIcon
                                    ? (colorScheme === 'dark' ? <LoginIconDark /> : <LoginIcon />)
                                    : (colorScheme === 'dark' ? <UserIconDark /> : <UserIcon />)}
                            </IconButton>
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>

    );
};

export default MainHeader;